export default __webpack_public_path__ + "static/media/logo_GMS.d4a29231.svg";